import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-24 text-center" data-testid="cancel-page">
      <div className="eyebrow mb-3">Order cancelled</div>
      <h1 className="aperture-h1 text-4xl md:text-5xl">No charge was made.</h1>
      <p className="mt-6 text-navy/70">Your cart is still saved. Take your time.</p>
      <div className="mt-10 flex gap-3 justify-center">
        <Link to="/cart" data-testid="cancel-back-cart" className="btn-primary px-6 py-3 text-xs uppercase tracking-widest rounded-sm">Return to Cart</Link>
        <Link to="/catalog" data-testid="cancel-catalog" className="border border-navy text-navy px-6 py-3 text-xs uppercase tracking-widest hover:bg-navy hover:text-white transition-colors duration-300 rounded-sm">Keep Browsing</Link>
      </div>
    </div>
  );
}
